var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanNavLogoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_142_67",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#F04e45;opacity:.2}.cls-3{fill:#F04e45}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1597",
    fill: "none",
    d: "M0 0H23V23H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6340",
    transform: "translate(84.842 -1.392)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1622",
    width: 7.086,
    height: 7.104,
    className: "cls-2",
    rx: 1,
    transform: "translate(-71.836 4.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    d: "M-75.885 4.034h-5.173a.916.916 0 0 0-.876.952v5.334a.916.916 0 0 0 .876.953h5.173a.917.917 0 0 0 .876-.953V4.986a.916.916 0 0 0-.876-.952zm-.444 5.766h-4.286V5.5h4.286z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    d: "M-69.14 5.407l-2.116 2.33-.8-.807a.647.647 0 0 0-.965.042.778.778 0 0 0-.181.534.769.769 0 0 0 .219.516l1.283 1.291a.643.643 0 0 0 .465.2.664.664 0 0 0 .485-.22l2.581-2.842a.765.765 0 0 0 .2-.527.772.772 0 0 0-.2-.523.649.649 0 0 0-.971.006z",
    className: "cls-3",
    transform: "translate(2.295 .37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1623",
    d: "M0 0H2.785V2.792H0z",
    className: "cls-2",
    transform: "translate(-79.864 6.256)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    d: "M-75.884 12.37h-5.173a.917.917 0 0 0-.876.953v5.334a.916.916 0 0 0 .876.952h5.173a.916.916 0 0 0 .876-.952v-5.334a.917.917 0 0 0-.876-.953zm-.444 5.768h-4.286v-4.3h4.286z",
    className: "cls-3",
    transform: "translate(0 2.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1624",
    d: "M0 0H2.785V2.792H0z",
    className: "cls-2",
    transform: "translate(-79.864 16.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    d: "M-67.711 12.37h-5.173a.917.917 0 0 0-.876.953v5.334a.916.916 0 0 0 .876.952h5.173a.916.916 0 0 0 .876-.952v-5.334a.917.917 0 0 0-.876-.953zm-.444 5.768h-4.286v-4.3h4.286z",
    className: "cls-3",
    transform: "translate(2.085 2.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1625",
    d: "M0 0H2.785V2.792H0z",
    className: "cls-2",
    transform: "translate(-69.606 16.734)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanNavLogoNew);
export default __webpack_public_path__ + "static/media/planNavLogoNew.1c42e05ff9924ab2f8e6ae85548c14d5.svg";
export { ForwardRef as ReactComponent };